import Model from 'src/app/core/models/model';

export default class ShapesModel extends Model {
  name: string;
  description: string;
  code: string;

  constructor() {
    super();
  }
}
